import { createPlatformAdminRepository } from "@upadelmatch/core/platform-admin";
import { db } from "@/core/firebase/client";

// Shared implementation (retry-through-hydration-race, fail-closed, legacy
// map-format support) lives in @upadelmatch/core/platform-admin; this file
// only binds it to THIS app's Firestore instance. usersmatch binds its own
// copy the same way (separate project, separate admins doc).
export const platformAdminRepository = createPlatformAdminRepository(db);
